import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { cn } from '@/utils/cn';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIsOpenGlobalSearchModal,
  setSearchKey,
} from '@/redux/reducers/search-reducer';
import { fetchTypingSearchList } from '@/redux/thunk/search-thunk';
import { getSearchResultPageUrl } from '@/url/product';
import Button from '../Button';
import Icon from '../Icon';

function SearchBar({ onSearch, className = '' }) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState('');

  const { currentSearchKey } = useSelector((state) => state.search);

  useEffect(() => {
    const initializeSearch = async () => {
      dispatch(fetchTypingSearchList({ searchKey: currentSearchKey }));
    };

    if (currentSearchKey.length >= 3) {
      initializeSearch();
    }
  }, [currentSearchKey]);

  useEffect(() => {
    if (currentSearchKey) {
      setSearchInput(currentSearchKey);
    }
  }, [currentSearchKey]);

  const handleSearchInputChange = (e) => {
    const searchValue = e.target.value;
    searchValue.trim();

    if (searchValue !== '' || searchValue !== null) {
      setSearchInput(searchValue);
      onSearch(searchValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && searchInput.trim() !== '') {
      // Get existing search keys from localStorage, default to empty array if none exist
      const existingKeys = JSON.parse(
        localStorage.getItem('searchKeys') || '[]',
      );

      // Add new search key to the beginning
      const updatedKeys = [searchInput, ...existingKeys];

      dispatch(setSearchKey(updatedKeys));
      // Save updated search keys back to localStorage
      localStorage.setItem('searchKeys', JSON.stringify(updatedKeys));

      dispatch(setIsOpenGlobalSearchModal(false));

      router.push(getSearchResultPageUrl(searchInput));
    }
  };

  const handleClearInput = () => {
    setSearchInput('');
    if (onSearch) {
      onSearch('');
    }
  };

  return (
    <div
      className={cn(
        'search-bar w-full max-w-[720px] lg:max-w-full h-[40px] flex items-center justify-center px-8 py-4 lg:px-12 bg-white border border-atelier rounded-[28px] gap-2',
        className,
      )}
    >
      <Button
        type="link"
        className="flex items-center justify-center ml-4 !p-0"
      >
        <Icon
          type="search"
          className="size-[24px]"
          color="#49525E"
          onClick={(e) => {
            e.stopPropagation();
            router.push(getSearchResultPageUrl(searchInput));
          }}
        />
      </Button>

      <input
        className="search-bar-input w-full border-none bg-transparent text-coarse-wool text-lg lg:text-base font-medium py-1 placeholder:text-lightslategray placeholder:text-base lg:placeholder:text-base placeholder:font-normal outline-none focus:outline-none"
        type="text"
        name="search"
        value={searchInput}
        onKeyDown={handleKeyDown}
        onChange={handleSearchInputChange}
        placeholder="Search here..."
      />

      <Button
        type="link"
        className={cn('invisible flex items-center justify-center ml-4 !p-0', {
          visible: searchInput,
        })}
        onClick={() => handleClearInput()}
      >
        <Icon type="close" className="size-[24px]" color="#49525E" />
      </Button>
    </div>
  );
}

export default SearchBar;
